import { createContext } from 'react';
import { TenantContextType } from '../types/tenant';

// Criação do contexto
export const TenantContext = createContext<TenantContextType | undefined>(undefined);
